"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment-timezone");
exports.now = function (timeZoneId) { return moment.tz(timeZoneId); };
exports.getMomentDate = function (date, timeZoneId) { return moment.tz(date, timeZoneId); };
exports.getUtcOffset = function (date, timeZoneId) { return exports.getMomentDate(date, timeZoneId).utcOffset(); };
exports.getDiffInHours = function (end, start) { return moment.duration(end.diff(start)).asHours(); };
exports.getDay = function (date, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        day: '2-digit'
    }, date, locale);
};
exports.getWeekDay = function (date, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        weekday: 'short'
    }, date, locale);
};
exports.getMonth = function (date, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        month: 'short'
    }, date, locale);
};
exports.getFullDate = function (timestamp, timeZone, showYear, locale, showTimeZone) {
    if (showTimeZone === void 0) { showTimeZone = false; }
    return formatWithIntl({
        timeZone: timeZone,
        year: showYear ? 'numeric' : undefined,
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: showTimeZone ? 'short' : undefined
    }, timestamp, locale);
};
exports.getLongDate = function (timestamp, timeZone, showYear, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        year: showYear ? 'numeric' : undefined
    }, timestamp, locale);
};
exports.getShortDate = function (timestamp, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        weekday: 'short',
        month: 'short',
        day: '2-digit'
    }, timestamp, locale);
};
exports.getYearMonthDay = function (timestamp, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    }, timestamp, locale);
};
exports.getTime = function (timestamp, timeZone, locale, showTimeZone) {
    if (showTimeZone === void 0) { showTimeZone = false; }
    return formatWithIntl({
        timeZone: timeZone,
        minute: '2-digit',
        hour: '2-digit',
        timeZoneName: showTimeZone ? 'short' : undefined
    }, timestamp, locale);
};
exports.formatDates = function (startDate, endDate, timeZone, forceShowYear, locale, showTimeZone) {
    if (forceShowYear === void 0) { forceShowYear = false; }
    if (locale === void 0) { locale = 'en-US'; }
    if (showTimeZone === void 0) { showTimeZone = false; }
    var start = exports.getMomentDate(startDate, timeZone);
    var end = endDate ? exports.getMomentDate(endDate, timeZone) : null;
    var showYear = !exports.isYearHidden(start, end) || forceShowYear;
    if (endDate) {
        var durationLessThan24h = moment.duration(end.diff(start)).asHours() < 24;
        var showStartDateTimeZone = showTimeZone && !durationLessThan24h;
        var formattedStart = exports.getFullDate(startDate, timeZone, showYear, locale, showStartDateTimeZone);
        if (durationLessThan24h) {
            return formattedStart + " \u2013 " + exports.getTime(endDate, timeZone, locale, showTimeZone);
        }
        else {
            return formattedStart + " \u2013 " + exports.getFullDate(endDate, timeZone, showYear, locale, showTimeZone);
        }
    }
    return "" + exports.getFullDate(startDate, timeZone, showYear, locale, showTimeZone);
};
exports.isYearHidden = function (start, end) {
    var current = moment();
    return current.isSame(start, 'year') && current.isSame(end || moment(), 'year');
};
var formatWithIntl = function (options, timestamp, locale) {
    try {
        return new Intl.DateTimeFormat(locale, options).format(new Date(timestamp));
    }
    catch (_a) {
        try {
            var offset = exports.getUtcOffset(timestamp, options.timeZone);
            var timeInTimeZone = exports.getMomentDate(timestamp)
                .add(offset, 'minutes')
                .toISOString();
            options.timeZone = 'UTC';
            return new Intl.DateTimeFormat(locale, options).format(new Date(timeInTimeZone));
        }
        catch (_b) {
            throw 'Date formatting is not supported';
        }
    }
};
exports.formatTimeZone = function (locale, timezone) {
    return new Intl.DateTimeFormat(locale, {
        timeZoneName: 'short',
        timeZone: timezone
    })
        .formatToParts(new Date())
        .find(function (part) { return part.type === 'timeZoneName'; }).value;
};
exports.getDifference = function (d1, d2) { return new Date(d1).getTime() - new Date(d2).getTime(); };
